<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        @if (showAvatar && user.avatar) {
        <img class="h-7 w-7 rounded-full" [src]="user.avatar" />
        }
        @if (!showAvatar || !user.avatar) {
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        }
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <div class="px-1">
        <button mat-menu-item>
            <span class="flex flex-col leading-[9px]">
                <span>Signed in as</span>
                <span class="mt-1.5 text-md font-medium">{{ systemUser?.email }}</span>
            </span>
        </button>
    </div>
    <mat-divider class="my-1"></mat-divider>
    <div class="px-1">
        <button mat-menu-item [routerLink]="['/site-administration']" class="h-4 max-h-1">
            <mat-icon [svgIcon]="'mat_outline:admin_panel_settings'" class="text-gray-600"></mat-icon>
            <span>Site Administration</span>
        </button>
    </div>
    <div class="px-1">
        <button mat-menu-item [routerLink]="['/settings']">
            <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'" class="text-gray-600"></mat-icon>
            <span>Settings</span>
        </button>
    </div>
    <mat-divider class="my-1"></mat-divider>
    <div class="px-1">
        <button mat-menu-item (click)="signOut()">
            <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'" class="text-gray-600"></mat-icon>
            <span>Sign out</span>
        </button>
    </div>
</mat-menu>